<template>
  <v-container class="pt-6 pb-0">
    <!-- pais -->
    <v-row>
      <v-select
        :label="t.ubic.pais"
        append-icon="expand_more"
        item-text="name"
        item-value="cod"
        clearable
        clear-icon="clear"
        v-model="ubicacion.pais"
        :items="paises"
        @input="getDeptos"
        @click:clear="limpiarPais"
      ></v-select>
    </v-row>
    <!-- depto -->
    <v-row>
      <v-select
        :label="t.ubic.depto"
        append-icon="expand_more"
        clearable
        clear-icon="clear"
        item-text="name"
        item-value="cod"
        v-model="ubicacion.depto"
        :items="deptosPais"
        @click:clear="limpiarDepto"
      ></v-select>
    </v-row>
    <!-- ciudad -->
    <v-row>
      <v-text-field
        :label="t.ubic.ciudad"
        v-model="ubicacion.ciudad"
      ></v-text-field>
    </v-row>
  </v-container>
</template>

<script>
import infoo from "../../plugins/infoo";

export default {
  name: "user-ubicacion",
  props: ["ubicacion"],
  computed: {
    deptos() {
      return this.$store.getters["app/helpers/deptos"];
    },
    deptosPais() {
      return this.deptos[this.ubicacion.pais] || [];
    },
    hoy() {
      return infoo.hoy.iso;
    },
    paises() {
      return this.$store.getters["app/helpers/paises"];
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    }
  },
  methods: {
    limpiarPais() {
      this.ubicacion.depto = "";
      this.ubicacion.ciudad = "";
    },
    limpiarDepto() {
      this.ubicacion.ciudad = "";
    },
    getDeptos(v) {
      if (!v) {
        this.ubicacion.depto = "";
        this.ubicacion.ciudad = "";
      } else {
        this.ubicacion.ciudad = "";
        this.$store.dispatch("app/helpers/getDeptos", v);
      }
    }
  }
};
</script>
